<template>
  <div v-if="isShow.isKVShow" class="pg-kv">
    <div class="title-wp">
      <div class="kv-year"></div>
      <div class="title">
        <div class="title-txt1"></div>
        <div class="title-txt2"></div>
        <div class="title-txt3"></div>
        <div class="title-txt4"></div>
      </div>
      <div class="title-sub"></div>
    </div>
    <div class="start-wp" @click="showNext">
      <div class="start-inner"></div>
      <div class="start-btn"></div>
    </div>
    <toast :toastMsg="msg" :ms="time" :isTrigger="trigger" />
  </div>
</template>

<script>
import { postData } from '../../assets/util'
import Toast from '../../components/toast/toast'
export default {
  name: 'PageKV',
  props: {
    isShow: Object
  },
  data() {
    return {
      trigger: false,
      msg: '',
      time: 1500,
    }
  },
  components: {
    Toast
  },
  methods: {
    showNext () {
      setTimeout(() => {
        this.$emit('nextPage', 'isPOShow');
      }, 200);
    },
    async fetchData() {
      const URLVerify = '/codes/2020/nfdw/game.php/Home/Index/JDOU_whoyouare';
      const URLGen = '/codes/2020/nfdw/game.php/Home/Index/JDOU_createUid';
      const verify = await postData(URLVerify);
      if (verify.status !== 1) {
        const gen = await postData(URLGen);
        if (gen.status === 1) {
          console.log('生成成功')
          window.location.href = 'https://www.jiandoukeji.com/h5/2020/southern-grid'
        } else {
          const msg = gen.msg || '无法识别用户';
          this.notify(msg);
        }
      }
    },
    notify(msg, time) {
      this.trigger = !this.trigger;
      this.msg = msg || '';
      this.time = time || 1500;
    }
  },
  created() {
    this.fetchData();
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg-kv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 6.25rem /* 100/16 */;
  background-image: url('./img/kv-bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: center;
}
.kv-year {
  width: 16.0625/2rem /* 257/16 */;
  height: 4.75/2rem /* 76/16 */;
  margin-left: 1.875rem /* 30/16 */;
  margin-bottom: 1.1875rem /* 19/16 */;
  background-image: url('./img/kv-year.png');
  background-size: cover;
  background-repeat: no-repeat;
  animation: transLeft .4s ease-out both;
  animation-delay: .8s;
}
.title {
  display: flex;
  margin-left: 1.5625rem /* 25/16 */;
  margin-bottom: 1.8125rem /* 29/16 */;
}
.title-txt1, .title-txt2, .title-txt3, .title-txt4 {
  width: 6.625/2rem /* 106/16 */;
  height: 6.625/2rem /* 106/16 */;
  margin-right: .8125rem /* 13/16 */;
  background-repeat: no-repeat;
  background-size: cover;
  animation: transLeft 1s both;
}
.title-txt1 {
  width: 3.9375/2rem /* 63/16 */;
  height: 5.0625/2rem /* 81/16 */;
  margin-top: 1rem;
  background-image: url('./img/kv-txt1.png');
  animation-delay: 1.2s;
}
.title-txt2 {
  width: 7.875/2rem /* 126/16 */;
  height: 6.9375/2rem /* 111/16 */;
  background-image: url('./img/kv-txt2.png');
  animation-delay: 1.6s;
}
.title-txt3 {
  width: 3.9375/2rem /* 63/16 */;
  height: 5.0625/2rem /* 81/16 */;
  margin-top: 1rem;
  background-image: url('./img/kv-txt3.png');
  animation-delay: 2s;
}
.title-txt4 {
  width: 6.625/2rem /* 106/16 */;
  height: 7.125/2rem /* 114/16 */;
  margin-right: 0;
  background-image: url('./img/kv-txt4.png');
  animation-delay: 2.4s;
}
.title-sub {
  width: 36.6875/2rem /* 587/16 */;
  height: 10.125/2rem /* 162/16 */;
  .bg('./img/kv-sub-title.png');
  animation: transLeft .8s ease-out both;
}
.start-wp {
  position: absolute;
  left: 50%;
  bottom: 26vw;
  margin-left: -21.875/4rem /* 350/16 */;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21.875/2rem /* 350/16 */;
  height: 21.875/2rem /* 350/16 */;
  // transform: translateY(20px);
  &:active {
    opacity: .6;
  }
}
.start-inner {
  width: 21.875/2rem /* 350/16 */;
  height: 21.875/2rem /* 350/16 */;
  .bg('./img/kv-ring.png');
  animation: rotateIt 20s linear infinite;
}
.start-btn {
  position: absolute;
  width: 10.75/2rem /* 172/16 */;
  height: 10.75/2rem /* 172/16 */;
  .bg('./img/kv-start.png');
}
@keyframes rotateIt {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes transLeft {
  from {
    opacity: 0;
    transform: translateX(-80%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
